@if (parameters$ | async; as parameters) {
  <nimbus-modal
    nimbusTheme
    id="confirm-modal"
    [ngClass]="{ 'loading-modal': parameters.loading }"
    [alertType]="parameters.alertType"
    [hideFooter]="parameters.hideFooter"
  >
    <header>{{ parameters.title | translate }}</header>
    <body>
      @if (parameters.loading) {
        <div class="modal-animation-container">
          <nimbus-spinner [small]="false"></nimbus-spinner>
        </div>
      }
      <span [innerHtml]="parameters.message | translate"></span>
    </body>
    <footer>
      @if (parameters.canReject) {
        <div nimbusMaterialButtonsRow>
          <button
            nimbusSecondaryButton
            [nimbusNegativeButton]="parameters.alertType === AlertType.Error"
            [class.button-validation]="parameters.alertType === AlertType.Validation"
            cdkFocusInitial
            (click)="close(false)"
          >
            {{ (parameters.rejectText ? parameters.rejectText : TranslationKeys.GeneralCancel) | translate }}
          </button>
          @if (parameters.buttons) {
            @for (button of parameters.buttons; track button) {
              <button
                nimbusPrimaryButton
                [nimbusNegativeButton]="parameters.alertType === AlertType.Error"
                [disabled]="button.isDisabled"
                [class.button-warning]="parameters.alertType === AlertType.Warning && !button.common"
                [class.button-red]="parameters.alertType === AlertType.Error && !button.common"
                [class.button-validation]="parameters.alertType === AlertType.Validation && !button.common"
                (click)="close(button.result)"
              >
                {{ button.text | translate }}
              </button>
            }
          } @else {
            <button
              nimbusPrimaryButton
              [nimbusNegativeButton]="parameters.alertType === AlertType.Error"
              [class.button-warning]="parameters.alertType === AlertType.Warning"
              [class.button-validation]="parameters.alertType === AlertType.Validation"
              (click)="close(true)"
            >
              {{ (parameters.confirmText ? parameters.confirmText : 'Confirm') | translate }}
            </button>
          }
        </div>
      } @else {
        <button
          nimbusPrimaryButton
          [nimbusNegativeButton]="parameters.alertType === AlertType.Error"
          [class.button-validation]="parameters.alertType === AlertType.Validation"
          (click)="close(true)"
        >
          {{ (parameters.confirmText ? parameters.confirmText : 'Confirm') | translate }}
        </button>
      }
    </footer>
  </nimbus-modal>
}
